import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {Documento} from '../model/documentos.model';
import {Page} from '../model/page.model';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {
  urlBase: String = `${environment.urlBase}/documento`;

  constructor(private  http: HttpClient) { }

  buscarDocumentos(idParceiro: number | undefined, idColigada: number | undefined, pageSize: number = 7,
                   pageIndex: number = 0): Observable<Page<Documento>> {
    const params = new HttpParams()
      .set('pageSize', pageSize.toString())
      .set('pageIndex', pageIndex.toString());
    return this.http.get<Page<Documento>>(
      `${this.urlBase}/parceiro/${idParceiro}/coligada/${idColigada}`,
      { params }
    );
  }

  buscarDocumentosFiltrado(filtro: any): Observable<Documento[]> {
    const params = new HttpParams().set('filtro', JSON.stringify(filtro));
    return this.http.get<Documento[]>(`${this.urlBase}/buscar-filtrada`, { params });
  }

  buscarArquivoDocumento(documentoUuid: string): Observable<IdNome> {
    const params = new HttpParams().set('uuid', documentoUuid);
    return this.http.get<IdNome>(`${this.urlBase}/buscar-arquivo`, { params });
  }
}
